(function () {
  'use strict';

  var CONFIG = {
    code: String(window.__SB_BUNDLE_DISCOUNT_CODE__ || 'BUNDLE10').trim(),
    bundleProperty: '_sb_bundle',
    enabled: window.__SB_AUTO_BUNDLE_DISCOUNT__ !== false,
    syncDelay: 250,
  };

  if (!CONFIG.enabled || !CONFIG.code) return;

  var normalizedCode = normalizeCode(CONFIG.code);
  var isSyncing = false;
  var isCheckoutRedirecting = false;
  var pendingSync = false;
  var syncTimer = null;

  function normalizeCode(code) {
    return String(code || '')
      .trim()
      .toUpperCase();
  }

  function uniqueCodes(codes) {
    var seen = {};
    var unique = [];

    codes.forEach(function (code) {
      var normalized = normalizeCode(code);
      if (!normalized || seen[normalized]) return;
      seen[normalized] = true;
      unique.push(String(code).trim());
    });

    return unique;
  }

  function cartUpdateUrl() {
    return (window.Theme && window.Theme.routes && window.Theme.routes.cart_update_url) || '/cart/update.js';
  }

  function checkoutUrl() {
    return '/checkout';
  }

  function getCartSectionIds() {
    var ids = [];
    var seen = {};
    var cartComponents = document.querySelectorAll('cart-items-component');

    cartComponents.forEach(function (component) {
      if (!(component instanceof HTMLElement)) return;
      var sectionId = component.dataset.sectionId;
      if (!sectionId || seen[sectionId]) return;
      seen[sectionId] = true;
      ids.push(sectionId);
    });

    return ids;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    }).then(function (response) {
      return response.json();
    });
  }

  function collectDiscountCodes(cart) {
    var codes = [];

    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        if (discount && discount.code) codes.push(discount.code);
      });
    }

    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (discount) {
        if (discount && discount.title) codes.push(discount.title);
      });
    }

    if (cart && Array.isArray(cart.items)) {
      cart.items.forEach(function (item) {
        var allocations = Array.isArray(item.line_level_discount_allocations)
          ? item.line_level_discount_allocations
          : [];

        allocations.forEach(function (allocation) {
          var discount = allocation && allocation.discount_application;
          if (discount && discount.type === 'discount_code' && discount.title) {
            codes.push(discount.title);
          }
        });
      });
    }

    return uniqueCodes(codes);
  }

  function isSubscriptionLine(item) {
    return Boolean(
      item &&
        (item.selling_plan_allocation ||
          item.selling_plan ||
          item.selling_plan_id ||
          (item.properties && item.properties._sb_bundle_child_selling_plan_id))
    );
  }

  function isSimpleBundleLine(item) {
    var properties = item && item.properties;
    if (!properties) return false;

    if (String(properties[CONFIG.bundleProperty] || '').toLowerCase() === 'true') {
      return true;
    }

    return Boolean(
      properties.Bundle ||
        properties._sb_bundle_parent_variant_id ||
        properties._sb_bundle_parent_handle ||
        properties._sb_bundle_parent_title ||
        properties._sb_bundle_parent_selling_plan_id ||
        properties._sb_bundle_child_selling_plan_id ||
        properties._sb_bundle_pricing_source
    );
  }

  function hasSubscriptionBundleLine(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some(function (item) {
      return isSimpleBundleLine(item) && isSubscriptionLine(item);
    });
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'simple-bundles-auto-discount',
          data: {
            source: 'simple-bundles-auto-discount',
            itemCount: cart && typeof cart.item_count === 'number' ? cart.item_count : 0,
            sections: (cart && cart.sections) || {},
          },
        },
      })
    );
  }

  function updateDiscountCodes(codes) {
    var payload = {
      discount: uniqueCodes(codes).join(','),
      sections_url: window.location.pathname,
    };
    var sectionIds = getCartSectionIds();

    if (sectionIds.length) {
      payload.sections = sectionIds.join(',');
    }

    return fetch(cartUpdateUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        dispatchCartUpdate(cart);
        return cart;
      });
  }

  function syncBundleDiscount() {
    if (isSyncing) {
      pendingSync = true;
      return Promise.resolve(null);
    }

    isSyncing = true;

    return fetchCart()
      .then(function (cart) {
        var existingCodes = collectDiscountCodes(cart);
        var hasBundle = hasSubscriptionBundleLine(cart);
        var hasCode = existingCodes.some(function (code) {
          return normalizeCode(code) === normalizedCode;
        });

        if (hasBundle && !hasCode) {
          return updateDiscountCodes(existingCodes.concat([CONFIG.code]));
        }

        if (!hasBundle && hasCode) {
          return updateDiscountCodes(
            existingCodes.filter(function (code) {
              return normalizeCode(code) !== normalizedCode;
            })
          );
        }

        return cart;
      })
      .catch(function (error) {
        console.warn('[SB Auto Discount] Unable to sync bundle discount.', error);
        return null;
      })
      .finally(function () {
        isSyncing = false;

        if (pendingSync) {
          pendingSync = false;
          scheduleSync(0);
        }
      });
  }

  function scheduleSync(delay) {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(syncBundleDiscount, typeof delay === 'number' ? delay : CONFIG.syncDelay);
  }

  function handleCheckoutSubmit(event) {
    var submitter = event.submitter;
    if (!(submitter instanceof HTMLElement) || submitter.getAttribute('name') !== 'checkout') return;
    if (isCheckoutRedirecting) return;

    event.preventDefault();
    isCheckoutRedirecting = true;

    syncBundleDiscount().finally(function () {
      window.location.href = checkoutUrl();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleSync(0);
  });

  document.addEventListener('cart:update', function (event) {
    if (event && event.detail && event.detail.data && event.detail.data.source === 'simple-bundles-auto-discount') {
      return;
    }

    scheduleSync();
  });

  document.addEventListener('discount:update', function () {
    scheduleSync();
  });

  document.addEventListener('simple-bundles:sync-discount', function () {
    scheduleSync(0);
    window.setTimeout(syncBundleDiscount, 350);
    window.setTimeout(syncBundleDiscount, 1000);
  });

  document.addEventListener('submit', handleCheckoutSubmit, true);

  window.SimpleBundlesAutoDiscount = {
    sync: syncBundleDiscount,
    config: CONFIG,
  };
})();
